// extracted by mini-css-extract-plugin
export var orderSummary = "_jm-0";
export var showMoreLessButton = "_jm-1";